import React from "react";
import { LoaderPosition, Loader } from "../../GlobalElements";

const LoaderSpinner = () => {
  return (
    <LoaderPosition>
      <Loader />
    </LoaderPosition>
  );
};

export default LoaderSpinner;
